import types from '../mutation-types'

const state = {
  user: {}
}

const getters = {
  getUserInfo: (state) => {
    return state.user
  }
}

const actions = {
  saveUserInfo({commit, state}, user) {
    commit(types.USER_INFO, user)
  }
}

const mutations = {
  [types.USER_INFO](state, user) {
    state.user = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js